import { __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { forwardRef } from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import { getLogger } from '../../utils/log/logger.js';
import { SuomifiThemeConsumer } from '../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../theme/SuomifiTheme/SuomifiTheme.js';
import { SpacingConsumer } from '../theme/SpacingProvider/SpacingProvider.js';
import { separateMarginProps } from '../theme/utils/spacing.js';
import { baseStyles } from './Heading.baseStyles.js';
import '../../reset/HtmlA/HtmlA.js';
import '../../reset/HtmlButton/HtmlButton.js';
import '../../reset/HtmlDiv/HtmlDiv.js';
import '../../reset/HtmlFieldSet/HtmlFieldSet.js';
import { HtmlH } from '../../reset/HtmlH/HtmlH.js';
import '../../reset/HtmlInput/HtmlInput.js';
import '../../reset/HtmlLabel/HtmlLabel.js';
import '../../reset/HtmlLegend/HtmlLegend.js';
import '../../reset/HtmlLi/HtmlLi.js';
import '../../reset/HtmlNav/HtmlNav.js';
import '../../reset/HtmlOl/HtmlOl.js';
import '../../reset/HtmlSpan/HtmlSpan.js';
import '../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../reset/HtmlUl/HtmlUl.js';
import '../../reset/HtmlTable/HtmlTable.js';
import '../../reset/HtmlTable/HtmlTableCaption.js';
import '../../reset/HtmlTable/HtmlTableHeader.js';
import '../../reset/HtmlTable/HtmlTableRow.js';
import '../../reset/HtmlTable/HtmlTableBody.js';
import '../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../reset/HtmlTable/HtmlTableCell.js';
import { filterDuplicateKeys } from '../../utils/common/common.js';

var baseClassName = 'fi-heading';
var smallScreenClassName = "".concat(baseClassName, "--small-screen");
var getSemanticVariant = function getSemanticVariant(variant) {
  if (variant === 'h1hero') return 'h1';
  return variant;
};
var StyledHeading = styled(function (_a) {
  var _b;
  var smallScreen = _a.smallScreen,
    className = _a.className;
    _a.globalMargins;
    _a.theme;
    var variant = _a.variant;
    _a.color;
    var asProp = _a.asProp,
    rest = __rest(_a, ["smallScreen", "className", "globalMargins", "theme", "variant", "color", "asProp"]);
  var _c = separateMarginProps(rest),
    passProps = _c[1];
  return /*#__PURE__*/React.createElement(HtmlH, __assign({}, passProps, {
    className: classnames(baseClassName, className, ["".concat(baseClassName, "--").concat(variant)], (_b = {}, _b[smallScreenClassName] = smallScreen, _b)),
    as: !!asProp ? asProp : getSemanticVariant(variant),
    style: __assign({}, passProps === null || passProps === void 0 ? void 0 : passProps.style)
  }));
}).withConfig({
  componentId: "sc-6ha6oi-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    color = _a.color,
    globalMargins = _a.globalMargins,
    rest = __rest(_a, ["theme", "color", "globalMargins"]);
  var _b = separateMarginProps(rest),
    marginProps = _b[0];
  var cleanedGlobalMargins = filterDuplicateKeys(globalMargins.button, marginProps);
  return baseStyles(theme, color, cleanedGlobalMargins, marginProps);
});
var Heading = /*#__PURE__*/forwardRef(function (props, ref) {
  var as = props.as,
    variant = props.variant,
    passProps = __rest(props, ["as", "variant"]);
  if (!variant) {
    getLogger().warn("Does not contain heading level (variant): ".concat(passProps.children));
    return null;
  }
  return /*#__PURE__*/React.createElement(SpacingConsumer, null, function (_a) {
    var margins = _a.margins;
    return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
      var suomifiTheme = _a.suomifiTheme;
      return /*#__PURE__*/React.createElement(StyledHeading, __assign({
        theme: suomifiTheme,
        globalMargins: margins,
        forwardedRef: ref,
        asProp: as
      }, passProps, {
        variant: variant
      }));
    });
  });
});
Heading.displayName = 'Heading';
var templateObject_1;

export { Heading };
//# sourceMappingURL=Heading.js.map
